import { i18n } from '@/plugins/i18n'

export default [
    {
        field: 'full_name',
        title: 'نام و نام خانوادگی',
        width: 100,
        sortable: true,
        textAlign: 'center',
        template: (row) => {
            return `<a href="/users/${row.user_id}/details">${row.full_name}</a>`
        },
    },
    {
        field: 'period',
        title: 'دوره',
        width: 80,
        textAlign: 'center',
        template: (row) => {
            return `<p>${row.period}</p>`
        },
    },
    {
        field: 'total_wage',
        title: 'کارمزد پرداختی (ریال)',
        textAlign: 'center',
        width: 110,
        template: (row) => {
            return `<p>${row.visitor_wage}</p>`
        },
    },
    {
        field: 'transaction_number',
        title: 'تعداد تراکنش',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.transaction_number}</p>`
        },
    },
    {
        field: 'total_amount',
        title: 'گردش کل (ریال)',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.total_amount}</p>`
        },
    },
    {
        field: 'last_update',
        title: 'آخرین بروزرسانی',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return `<p>${row.last_update}</p>`
        },
    },
    {
        field: 'setting',
        title: 'تنظیمات',
        textAlign: 'center',
        width: 80,
        template: (row) => {
            return '<a href="/pos-setting/' + row.user_id + '/details"><span dir="ltr"><i class="fa fa-eye"></i></span></a>'
        },
    },

]